import React from 'react';
import { Link } from 'react-router-dom';

import './SideBarNavigationItem.css';

type SideBarNavigationItemProps = {
    isActive?: boolean,
    text: string,
    link: string,
    iconClassName: string
}

export const SideBarNavigationItem = (props: SideBarNavigationItemProps) => {

    let classForFont = props.isActive ? 'fontBold':'fontNormal';

    return (<Link to={props.link}><a className={classForFont + " list-group-item waves-effect"}>
        <i style={{ width: '30px', textAlign: 'center' }} className={props.iconClassName + " mr-3"}></i>{props.text}
    </a></Link>)
}